module.exports = __webpack_public_path__ + "static/img/default-card.e71c62bf.png";